import { NavigationEnd, PRIMARY_OUTLET, Router, UrlSegment, UrlTree } from "@angular/router";
import { isEqual } from "lodash-es";
import { Observable, of } from "rxjs";
import { filter, map, switchMap, takeUntil } from "rxjs/operators";
import { AvanoMenuEntry } from "./avano-menu.common";

export interface SelfExpandableAvanoMenu {
  router: Router;
  expandOnNavigation$: Observable<boolean>;
  destroyed$: Observable<any>;
  menuEntries: AvanoMenuEntry[];
}
export class AvanoMenuExpander {
  constructor(private avanoMenu: SelfExpandableAvanoMenu) {

  }
  initExpandOnNavigationFeature() {
    if (!this.avanoMenu) throw new Error("AvanoMenuExpander is not initialized");
    this.avanoMenu.expandOnNavigation$.pipe(
      switchMap((shouldExpand) => shouldExpand ? 
        this.avanoMenu.router.events.pipe(
          filter((event) => event instanceof NavigationEnd && event.urlAfterRedirects !== "/"),
          map((navigationEndEvent: NavigationEnd) => navigationEndEvent.urlAfterRedirects)
        ) : of(null) ),
      takeUntil(this.avanoMenu.destroyed$)
    ).subscribe({
      next: urlAfterRedirects => {
        this.expandMenuItemsForUrl(urlAfterRedirects);
      }
    })
  }

  expandMenuItemsForUrl(relativeUrl: string): void {
    const urlTree = this.avanoMenu.router.parseUrl(relativeUrl);
    const urlSegments = this.getTreeUrlSegments(urlTree);
    for(const menuItem of (this.avanoMenu.menuEntries ?? [])) {
      const menuItemPathMatchingUrl = this.findAncestorMatchingUrl(menuItem, urlSegments, [menuItem]);
      if (menuItemPathMatchingUrl?.length > 0) {
        menuItemPathMatchingUrl.forEach(itemToExpand => itemToExpand.isExpanded = true);
        break;
      }
    }
  }
  
  private routesMatch(currentUrlSegments: UrlSegment[], menuItemRouterLink: any[] | string): boolean {
    const segmentsToPath = (segments: UrlSegment[]) => segments.map(segment => segment.path);
    menuItemRouterLink = Array.isArray(menuItemRouterLink) ? menuItemRouterLink : menuItemRouterLink.split('/')
    const menuItemPathSegments = this.avanoMenu.router.createUrlTree(menuItemRouterLink).root.children[PRIMARY_OUTLET].segments;
    
    const menuItemPathParts = segmentsToPath(menuItemPathSegments);
    const urlPathParts = segmentsToPath(currentUrlSegments)
    return isEqual(menuItemPathParts, urlPathParts);
  }

  private getTreeUrlSegments(urlTree: UrlTree): UrlSegment[] {
    return urlTree.root.numberOfChildren > 0 ? 
      urlTree.root.children[PRIMARY_OUTLET].segments :
      []
  }

  private findAncestorMatchingUrl(menuItem: AvanoMenuEntry, currentUrlSegments: UrlSegment[], parents: AvanoMenuEntry[]): AvanoMenuEntry[] {
    if (!menuItem) return undefined;
    if (menuItem.routerLink && this.routesMatch(currentUrlSegments, menuItem.routerLink)) {
      return parents;
    }
    if (menuItem.children) {
      const foundChild = menuItem.children.find((child) => this.findAncestorMatchingUrl(child, currentUrlSegments, [...parents, child]) !== undefined);
      if (foundChild) {
        return parents;
      }
    }
    return undefined;
  }
}